<template>
  <sell-lack-check
    :pagetitle="`销售报缺审批详情`"
    :snaId="snaId"
  ></sell-lack-check>
</template>

<script>
import sellLackCheck from '@/views/workbench/workCheckManage/sellLackCheck/sellLackCheck'
import checkMixin from '@/mixin/checkMixin'
import routerMixin from '@/mixin/routerMixin'
export default {
  name: 'sellLackCheckDetail',
  data () {
    return {}
  },
  components: {
    sellLackCheck
  },
  mixins: [checkMixin, routerMixin]
}
</script>

<style scoped></style>
